const delegate = require('delegate');
const selectors = {
	progressSavingsWrapper: '.product-progress-savings--wrapper',
	progressSavingsWrapperInner: '.product-progress-savings-wrapper__inner',
	progressDetails: '.product-progress-details',
	productConditions: '.product-conditions-wrapper__inner',
	productProgress: '.product-progress',
	productQuantitySelectorValue: '.product-quantity-selector',
	sizeTableButton: '.size-table-trigger-button',
	sizeTableModal: '.modal--size-table',
	sizeTableOptions: '.product-size-table-options'
};
const productProgress = document.querySelector(selectors.productProgress)
const productConditions = document.querySelectorAll(selectors.productConditions)
const productQuantitySelector = document.querySelector(selectors.productQuantitySelectorValue)
//Toggle show more detail, add class with opacity change to create transition
function showMoreDetails() {
	const progressSavingsWrapper = document.querySelector(selectors.progressSavingsWrapper)
	if (!!progressSavingsWrapper) {
		const progressDetails = progressSavingsWrapper.querySelector(selectors.progressDetails)
		const progressSavingsWrapperInner = progressSavingsWrapper.querySelector(selectors.progressSavingsWrapperInner)
		if(!!progressDetails){
			const progressDetailsShow = progressDetails.querySelector('.product-progress-details-show')	
			const progressDetailsHide = progressDetails.querySelector('.product-progress-details-hide')	

			progressDetails.addEventListener('click', function(){
				if (progressSavingsWrapper.classList.contains('product-progress-savings--active')) {
					if (!!progressSavingsWrapperInner) {
						progressSavingsWrapperInner.classList.add('hidden')
						setTimeout(function () {
							progressSavingsWrapper.classList.remove('product-progress-savings--active')
						}, 100);
						if (!!progressDetailsHide && !!progressDetailsShow) {
							progressDetailsShow.classList.remove('hidden')
							progressDetailsHide.classList.add('hidden')
						}
					}
				} else {
					if (!!progressSavingsWrapperInner) {
						progressSavingsWrapperInner.classList.remove('hidden')
						setTimeout(function () {
							progressSavingsWrapper.classList.add('product-progress-savings--active')
							if (!!progressDetailsHide) {
								progressDetailsHide.classList.remove('hidden')
							}
						}, 100);
					
						if (!!progressDetailsShow) {
							progressDetailsShow.classList.add('hidden')
						}

					}
				}
			})
		}
	}
}

//Create the percantage divs and their correct placement
function progressBarPercantage(){
	let savingsCondition = 0;
	if (!!productConditions) {
		productConditions.forEach((el, index) =>{
			let percantageDiv = document.createElement('div')
			percantageDiv.className= 'product-progress-bar--percantage'

			if (!!el.getAttribute('data-savings-condition')) {
				savingsCondition = Number(el.getAttribute('data-savings-condition'))
			}
			percantageDiv.innerHTML = savingsCondition + ' %'

			if (!!productProgress) {
				productProgress.appendChild(percantageDiv)
			}
		})
		var percantagesAll = document.querySelectorAll('.product-progress-bar--percantage')
		if (!!percantagesAll[0]) {
			percantagesAll[0].style.left = '30%'
		}
		if (!!percantagesAll[1]) {
			percantagesAll[1].style.left = '60%'
		}	
		if (!!percantagesAll[2]) {
			percantagesAll[2].style.left = '87%'
		}
	}
}

//Fill the progress bar
function progressBarWidth(){
	let productQuantitySelectorValue = ''
	
	if (!!productQuantitySelector) {
		productQuantitySelectorValue = Number(productQuantitySelector.value)
	}
	let conditionQuantity= 0
	let conditionSavings = 0
	let tempWidth = 10;
	let totalWidth = 0;
	let savingsArray = [];
	let quantitiesArray = [];
	let missingQuantitiesArray = []
	let missingProducts = 0;
	let progressBarText = document.querySelector('.product-progress-bar--text')
	let progressBarTextReached = document.querySelector('.product-progress-bar--text-reached')
	let percentageSavingsReached = window.languages.percentageSavingsReached
	let missingProductsText = window.languages.missingProducts

	if (!!productConditions) {
		productConditions.forEach((el, index, array) => {
			//Get the qty number and the savings percentage
			if (!!el.getAttribute('data-quantity-condition')) {
				conditionQuantity = Number(el.getAttribute('data-quantity-condition'))
			}
			if (!!el.getAttribute('data-savings-condition')) {
				conditionSavings = Number(el.getAttribute('data-savings-condition'))
			}

			quantitiesArray.push(conditionQuantity)
			savingsArray.push(conditionSavings)
			
			//Change the background color of the progress bar and  set the width once qty reached
			if (!!productQuantitySelectorValue) {
				tempWidth = conditionQuantity;

				let productProgressBar = ''
				if (!!productProgress) {
					productProgressBar = productProgress.querySelector('#product-progress-bar')
				}
				//Check if the current selected qty is bigger than the smallest condition so we can change the background color
				if (!!productProgressBar) {
					if (index === 0) {
						if (productQuantitySelectorValue >= tempWidth) {
							productProgressBar.style.backgroundColor = '#FA9189'
						}else {
							productProgressBar.style.backgroundColor = '#A59F9F'
						}
					}

				
					totalWidth = (productQuantitySelectorValue / tempWidth) * 100
					
					//Check if the current selected qty is bigger than the biggest condition and set the width to 100 so we dont get endless progressbar or set to current progress
					if (index === array.length - 1){ 
						if (productQuantitySelectorValue >= tempWidth) {
							totalWidth = 100
						}
						productProgressBar.style.width = `${totalWidth}%`
					} else {
						totalWidth = (productQuantitySelectorValue / tempWidth) * 100
						productProgressBar.style.width = `${totalWidth}%`
					}
				}
				missingProducts = conditionQuantity	- productQuantitySelectorValue
				missingQuantitiesArray.push(missingProducts)
			}
			
		})
		
		//Change the savings text once one of the conditions is reached
		if (!!savingsArray) {
			savingsArray.forEach((el, indx) => {
				if (!!progressBarText && !!quantitiesArray && !!productQuantitySelectorValue) {
					if (productQuantitySelectorValue >= quantitiesArray[indx]){			
						progressBarText.innerHTML = percentageSavingsReached.replace('{{percentage}}', el)
					} else if(quantitiesArray[0] > productQuantitySelectorValue) {
						progressBarText.innerHTML = ''
					}
				}
			})
		}
		
 		//Change the missing products to get percentage saving text (blocks limit is 3 thats why the index)
		if(!!missingQuantitiesArray){
			missingQuantitiesArray.forEach((el) => {
				if (!!progressBarText && !!progressBarTextReached && !!productQuantitySelectorValue) {
					if (el > 0){
						if(!!missingQuantitiesArray[0] && missingQuantitiesArray[1] && productQuantitySelectorValue < missingQuantitiesArray[1]) {
							progressBarTextReached.innerHTML = missingProductsText.replace('{{products}}', missingQuantitiesArray[0]).replace('{{percentage}}', savingsArray[0])
						} else if (!!missingQuantitiesArray[1] && productQuantitySelectorValue >= missingQuantitiesArray[1] && missingQuantitiesArray[1] > 0){
							progressBarTextReached.innerHTML = missingProductsText.replace('{{products}}', missingQuantitiesArray[1]).replace('{{percentage}}', savingsArray[1])
						}else if (!!missingQuantitiesArray[2] && productQuantitySelectorValue >= missingQuantitiesArray[2]){
							progressBarTextReached.innerHTML = missingProductsText.replace('{{products}}', missingQuantitiesArray[2]).replace('{{percentage}}', savingsArray[2])
						}
					} else {
						progressBarTextReached.innerHTML = ''
					}
				}
			})
		}
	}
}
var productConditionOne = 0
var productConditionTwo = 0
var productConditionThree = 0
if (!!productConditions[0]) {
	productConditionOne = Number(productConditions[0].getAttribute('data-quantity-condition'))
}
if (!!productConditions[1]) {
	productConditionTwo = Number(productConditions[1].getAttribute('data-quantity-condition'))
}
if (!!productConditions[2]) {
	productConditionThree = Number(productConditions[2].getAttribute('data-quantity-condition'))
}
function percentageReached(){	
	if (!!productQuantitySelector) {
		var productQuantitySelectorValueNum = Number(productQuantitySelector.value)
		var progressBarPercantages = document.querySelectorAll('.product-progress-bar--percantage')
		if(!!productConditions){
			if(!!progressBarPercantages) {
				if (!!productConditionOne && !!progressBarPercantages[0]) {
					if(productConditionOne === productQuantitySelectorValueNum) {
						progressBarPercantages[0].classList.add('text--bold')
					} else if(productConditionOne > productQuantitySelectorValueNum) {
						progressBarPercantages[0].classList.remove('text--bold')
					}
				}
				if (!!productConditionTwo && !!progressBarPercantages[1]) {
					if( productConditionTwo === productQuantitySelectorValueNum) {
						progressBarPercantages[1].classList.add('text--bold')
					} else if(productConditionTwo > productQuantitySelectorValueNum) {
						progressBarPercantages[1].classList.remove('text--bold')
					}
				}
				if (!!productConditionThree && !!progressBarPercantages[2]) {
					if(productConditionThree === productQuantitySelectorValueNum) {
						progressBarPercantages[2].classList.add('text--bold')
					} else if(productConditionThree > productQuantitySelectorValueNum) {
						progressBarPercantages[2].classList.remove('text--bold')
					}
				}
			}
		}
	}
}

//Toggle the active class of the boxes with the conditions and change the qty selector value on click
function changeQty(){
	if (!!productConditions) {
		callEvent(productConditions, productQuantitySelector);
	}
}

const callEvent = (productConditions, productQuantitySelector) => {
	productConditions.forEach((el) => {
		el.addEventListener('click', () => {
			let newQnty = 1
			if(!!el.getAttribute('data-quantity-condition')) {
				newQnty = el.getAttribute('data-quantity-condition')
			}
			if(!!productQuantitySelector){
				if (el.parentNode.classList.contains('product-conditions-wrapper--active')) {
					productQuantitySelector.value = 1
				} else {
					productQuantitySelector.value = newQnty
				}
			}
			
			el.parentNode.classList.toggle('product-conditions-wrapper--active');
			productConditions.forEach(productCondition => productCondition !== el && productCondition.parentNode.classList.remove('product-conditions-wrapper--active'));
			
			document.dispatchEvent(new CustomEvent('qty:changed'))
		});
	});
};

//If quantity changed from the selector toggle the active class for the savings boxes with the conditions
function changeQtyBox(productConditions, productQuantitySelector){
	productConditions.forEach((condition,idx, array) => {
		let lastIndex = 0
		if (idx === array.length - 1){ 
			lastIndex = Number(productConditions[idx].getAttribute('data-quantity-condition'))
		}
		if (!!productQuantitySelector) {
			if (condition.getAttribute('data-quantity-condition') === productQuantitySelector.value) {
				condition.parentNode.classList.add('product-conditions-wrapper--active');
			}else if(productQuantitySelector.value > lastIndex && lastIndex !== 0){
				condition.parentNode.classList.add('product-conditions-wrapper--active');
			}else {
				condition.parentNode.classList.remove('product-conditions-wrapper--active');
			}
		}
	});
};

function showSizeTable() {
	const sizeTableButton =  document.querySelector(selectors.sizeTableButton)
	const sizeTableModal = document.querySelector(selectors.sizeTableModal)
	if (!!sizeTableButton) {
		sizeTableButton.addEventListener('click', ()=>{
			document.documentElement.classList.add('is-locked');
			if (!!sizeTableModal) {
				sizeTableModal.setAttribute('aria-hidden', 'false');
			}
		})
	}
  // we check if we click outside the modal
  delegate(selectors.sizeTableModal, 'click', function(e) {
    if (e.target === sizeTableModal){
      closeSizeTable(sizeTableModal)
    }
  }, false);

  // Check if we click close button
  delegate(selectors.sizeTableModal, '[data-action="close-modal"]', 'click', function(e) {
		e.preventDefault()
    closeSizeTable(sizeTableModal)
	document.documentElement.classList.remove('is-locked');
  }, false);
}

function closeSizeTable(modal){
  modal.setAttribute('aria-hidden', 'true');
  document.documentElement.classList.remove('is-locked');
}

function sizeTableOptionsToggle() {
	const sizeTableOptions = document.querySelector(selectors.sizeTableOptions)
	if (!!sizeTableOptions) {
		const sizeTableOptionsButtons	= sizeTableOptions.querySelectorAll('.size-table-button')
		sizeTableOptionsButtons.forEach( button => {
			button.addEventListener('click', el => {
				const tableTrigger = el.target.getAttribute('data-table-trigger')
				const tableOption1 = document.getElementById('size-table-option-1')
				const tableOption2 = document.getElementById('size-table-option-2')

				if (!!tableTrigger) {
					if (tableTrigger === tableOption1.id) {
						if (!!tableOption1) {
							if (tableOption1.getAttribute('aria-hidden') === 'true') {
								tableOption2.setAttribute('aria-hidden', 'true');
								tableOption1.setAttribute('aria-hidden', 'false');
							}
						}
					}else if (tableTrigger === tableOption2.id) {
						if (!!tableOption2) {
							if (tableOption2.getAttribute('aria-hidden') === 'true') {
								tableOption1.setAttribute('aria-hidden', 'true');
								tableOption2.setAttribute('aria-hidden', 'false');
							}
						}
					}
				}
				el.target.classList.toggle('size-table-button--active');
				sizeTableOptionsButtons.forEach(sizeTableOptionsButton => sizeTableOptionsButton !== el.target && sizeTableOptionsButton.classList.remove('size-table-button--active'))
			})
		})
	}
}
function showSavingsSelector() {
	const selectorLabel = document.querySelector('.dropdown-wide--custom-select')
	const selectorDiscountConditions = document.querySelectorAll('.discount--conditions')
	let percentageSavings = window.languages.percentageSavings
	let percentageSavingsText = ''

	if (!!selectorDiscountConditions) {
		if (!!selectorLabel) {
			const selectorOptions = selectorLabel.querySelectorAll('.quantity-selector__value')
			if(!!selectorOptions){
				selectorDiscountConditions.forEach((condition, index, array)  => {
					if (!!selectorDiscountConditions) {
						selectorOptions.forEach(option =>{
							if(!!option.parentNode.getAttribute('data-enable-text') && option.parentNode.getAttribute('data-enable-text') === 'true'){
								const optionValue = Number(option.value)
								const selectorQquantityConditions = Number(condition.getAttribute('data-quantity-condition'))
								const selectorSavingsConditions = Number(condition.getAttribute('data-savings'))
								if (index !== array.length - 1){
									if (optionValue === selectorQquantityConditions) {
										percentageSavingsText = percentageSavings.replace('{{percentage}}', selectorSavingsConditions)
										option.innerHTML = `<span class='percentage-option--savings'>${percentageSavingsText}</span> <span>${optionValue}</span>`
									}
								} else {
									if (optionValue >= selectorQquantityConditions) {
										percentageSavingsText = percentageSavings.replace('{{percentage}}', selectorSavingsConditions)
										option.innerHTML = `<span class='percentage-option--savings'>${percentageSavingsText}</span> <span>${optionValue}</span>`
									}
								}
							}
						})
					}
				})
			}
		}
		if (!!selectorDiscountConditions) {
			selectorDiscountConditions.forEach(condition => {
				const selectorQquantityCondition = Number(condition.getAttribute('data-quantity-condition'))
				const selectorSavingsCondition = Number(condition.getAttribute('data-savings'))
				const productPageForm = document.querySelector('.product-form')
				if (!!productPageForm) {
					const priceParentElemnt = productPageForm.querySelector('.price')
					const priceElemnt = priceParentElemnt.querySelector('.product-price')
					const priceNewElemnt = document.createElement('span')
					priceNewElemnt.className = 'price--new-savings'
					let productPriceNumber = Number(priceElemnt.getAttribute('data-product-prie')) / 100
					let savingsClaculated = 0
					let totalClaculated = 0
					
					if (!document.querySelector('.price--new-savings')) {
						priceParentElemnt.appendChild(priceNewElemnt)
					}
					
					if(Number(productQuantitySelector.value) >= Number(selectorDiscountConditions[0].getAttribute('data-quantity-condition'))) {
						if(Number(productQuantitySelector.value) >= selectorQquantityCondition ) {
							savingsClaculated = (productPriceNumber * selectorSavingsCondition) / 100
							totalClaculated = (productPriceNumber - savingsClaculated).toFixed(2).replace(/\./, ',') + ' €'
							priceElemnt.classList.add('price--compare')
							document.querySelector('.price--new-savings').innerHTML = totalClaculated
							priceNewElemnt.classList.add('price--highlight')
						}
					} else {
						priceElemnt.classList.remove('price--compare')
						document.querySelector('.price--new-savings').remove()
					}
					
				}
			})
		}
	}
}
document.addEventListener('DOMContentLoaded', () => {
	showMoreDetails()
	showSavingsSelector()
	progressBarPercantage()
	progressBarWidth()
	changeQty()
	showSizeTable()
	sizeTableOptionsToggle()
})
document.addEventListener('qty:changed', () => {
	progressBarWidth()
	percentageReached()
	showSavingsSelector()

	if (!!productConditions) {
		changeQtyBox(productConditions, productQuantitySelector)
	}
})
